module.exports = __webpack_public_path__ + "static/MSA-Awards-cf09c7b7a90cef89de3df51d73d0cd67.png";